// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1btFT","col":"CardReaderDesc_col__3TTlP","label":"CardReaderDesc_label__24n_d"};